/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeAIcon16Regular = forwardRef('MediaAudioVolumeAIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.416 1.24A.95.95 0 0 1 12 1.946v12.106a.95.95 0 0 1-1.584.708L6.213 11H3.5A1.5 1.5 0 0 1 2 9.5v-3A1.5 1.5 0 0 1 3.5 5h2.713l4.203-3.76Zm.084 1.937L7.142 6.182a1.25 1.25 0 0 1-.833.318H3.5v3h2.809c.308 0 .604.113.833.318l3.358 3.005V3.177Z" })));
});
